/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_2_RoleInputs */

const en_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein distance verification`)
};

const de_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein-Distanz-Prüfung`)
};

const fr_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification par distance de Levenshtein`)
};

const es_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación por distancia de Levenshtein`)
};

const it_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica tramite distanza di Levenshtein`)
};

const nl_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein-afstandsverificatie`)
};

const pl_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja odległością Levenshteina`)
};

const fi_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein-etäisyyden vahvistus`)
};

const da_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein-afstandsverifikation`)
};

const sv_landing_testimonial_2_role = /** @type {(inputs: Landing_Testimonial_2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levenshtein-avståndsverifiering`)
};

/**
* | output |
* | --- |
* | "Levenshtein distance verification" |
*
* @param {Landing_Testimonial_2_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_2_role = /** @type {((inputs?: Landing_Testimonial_2_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_2_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_2_role(inputs)
	if (locale === "fr") return fr_landing_testimonial_2_role(inputs)
	if (locale === "es") return es_landing_testimonial_2_role(inputs)
	if (locale === "it") return it_landing_testimonial_2_role(inputs)
	if (locale === "nl") return nl_landing_testimonial_2_role(inputs)
	if (locale === "pl") return pl_landing_testimonial_2_role(inputs)
	if (locale === "fi") return fi_landing_testimonial_2_role(inputs)
	if (locale === "da") return da_landing_testimonial_2_role(inputs)
	if (locale === "sv") return sv_landing_testimonial_2_role(inputs)
	return en_landing_testimonial_2_role(inputs)
});